export enum TicketStatusEnum{
  PENDING='PENDING',
  ANSWERED='ANSWERED',
  CLOSED_BY_USER='CLOSED_BY_USER',
  CLOSED_BY_ADMIN='CLOSED_BY_ADMIN',
  CLOSED_BY_SYSTEM='CLOSED_BY_SYSTEM'
}
